<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal" style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-text-input label="Descrizione"
                         value="Olio Agip"></cv-text-input>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-combo-box label="Seleziona" title="Unità di misura"
                        value="Kg" :auto-filter="true"
                        :options="options_um"></cv-combo-box>
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="8">
          <cv-toggle label="Destinazione"
                     :value="flgPerMacchine_value"
                     v-model="flgPerMacchine"
                     :hide-label="false">
            <template slot="text-left">Uso Generico</template>
            <template slot="text-right">Per le Macchine</template>
          </cv-toggle>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="Scorta Minima"
                        value="0"></cv-text-input>
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="Quantità"
                         value="0"></cv-text-input>
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="Prezzo Medio" readonly
                         value="0"></cv-text-input>
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="Valore Totale" readonly
                         value="0"></cv-text-input>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-text-area label="Note" value=""></cv-text-area>
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <Bottoniera testo_nuovo="Nuovo Materiale"
                testo_salva="Salva Materiale"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" >

    </Bottoniera>
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";

export default {

  name: "Materiali",
  components: { Bottoniera },
  data: function() {
    return {
      flgPerMacchine_value: "true",
      flgPerMacchine: true,
      options_um: [
        {
          value: "1",
          label: "Kg",
          name: "1"
        },
        {
          value: "2",
          label: "Litri",
          name: "2"
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>